import { ThemeProvider } from "@emotion/react";
import { uiucTheme } from "../../styles/theme";
import { Box, Typography } from "@mui/material";
import ReactPlayer from "react-player";

const ClassSection: React.FC = () => {
  return (
    <ThemeProvider theme={uiucTheme}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "left",
          alignItems: "left",
          background: uiucTheme.palette.background.default,
        }}
      >
        <Typography
          variant="h4"
          color="primary"
          sx={{
            padding: 1,
            borderBottom: 4,
            borderWidth: "40%",
            marginLeft: 2,
          }}
        >
          Notable Coursework
        </Typography>
      </Box>
      <Box
        sx={{
          background: uiucTheme.palette.background.default,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      ></Box>
      <Box
        sx={{
          width: "100%",
          display: "grid",
          justifyContent: "center",
          gridTemplateColumns: "1fr 1fr",
          alignItems: "center",
          verticalAlign: "top",
          background: uiucTheme.palette.background.default,
        }}
      >
        <Box
          sx={{
            padding: "2rem",
            height: "100%",
          }}
        >
          <Typography
            variant="h4"
            color="primary"
            sx={{
              padding: 1,
              borderBottom: 4,
              borderWidth: "40%",
            }}
          >
            CS 415 (Game Development)
          </Typography>
          <Typography variant="body1" color="primary" sx={{ margin: 2 }}>
            This course was primarily taught using Unreal Engine 5. Throughout
            the course we developed various games, including our final project,
            a platforming game with puzzles, enemies, and more. Seen below is
            our video, narrated and walked through by my groupmate, Andre
            Schreiber.
          </Typography>
          <ReactPlayer
            url={"https://youtu.be/dW5cgozjM1c"}
            controls={true}
            width="100%"
          />
        </Box>
        <Box
          sx={{
            padding: "2rem",
            height: "100%",
          }}
        >
          <Typography
            variant="h4"
            color="primary"
            sx={{
              padding: 1,
              borderBottom: 4,
              borderWidth: "40%",
            }}
          >
            CS 437 (Networked IoT Systems)
          </Typography>
          <Typography variant="body1" color="primary" sx={{ margin: 2 }}>
            This course focused on the Internet of Things. I became familiar
            with a wide variety of networking topics like firewalling,
            networking protocols, and different AWS services. Seen below is my
            group&apos;s final project, an app that uses the OpenCV library to
            monitor traffic in gyms and other recreation facilities.
          </Typography>
          <ReactPlayer
            url={"https://youtu.be/GeiedPjgTDQ"}
            controls={true}
            width="100%"
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
};
export default ClassSection;
